import api from './api';

export const fetchOrderTemplates = async (account_id: number): Promise<Array<Option>> => {
  if (!account_id) throw Error('No account_id');
  const rawResponse = await api.get(
    `${import.meta.env.VITE_API}/${account_id}/api/v1/order_templates.json`,
  );
  return rawResponse.data;
};
